/**
 * Temporary route prefix configuration
 * 
 * TODO: REMOVE BEFORE PRODUCTION RELEASE!
 * This is a temporary prefix added to avoid conflicts with the old search in PROD.
 * When ready to replace the old search with the new one, simply set ROUTE_PREFIX to empty string
 * and regenerate routes.
 * 
 * To remove the prefix:
 * 1. Change ROUTE_PREFIX from '/omni-search' to ''
 * 2. Run: npm run build-routes
 * 3. Deploy
 */
export const ROUTE_PREFIX = '/omni-search' // TODO: Change to '' before production release

/**
 * Helper function to add the temporary prefix to a path
 */
export const addRoutePrefix = (path: string): string => {
	if (!ROUTE_PREFIX) return path
	return `${ROUTE_PREFIX}${path}`
}

/**
 * Helper function to remove the temporary prefix from a path (used in comparisons)
 */
export const removeRoutePrefix = (path: string): string => {
	if (!ROUTE_PREFIX) return path
	return path.startsWith(ROUTE_PREFIX) ? path.substring(ROUTE_PREFIX.length) : path
}
